/* eslint-disable @next/next/no-img-element */
import { Icon } from '@/components'
import { URL_DECOR } from '@/constants/ui'
import { IListPromotionItem } from '@/features/coupon/types'
import { isTheAutoAppliedVoucher, isUnavailableVoucher } from '@/features/help/utils/helper'
import { formatNumber } from '@/utils/helpers'
import {
  Box,
  BoxProps,
  Checkbox,
  CheckboxProps,
  IconButton,
  IconButtonProps,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material'
import dayjs from 'dayjs'
import parser from 'html-react-parser'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

type VoucherItemProps = {
  item: IListPromotionItem
  isActive: boolean
  toggleVoucher: () => void
  props?: Omit<BoxProps, 'children'>
  expiredTextProps?: {
    position?: 'right' | 'bottom'
    props?: Omit<BoxProps, 'children'>
  }
  tag?: string
  iconProps?: Omit<IconButtonProps, 'children'>
  type?: 'radio' | 'checkbox'
  checkboxProps?: Omit<CheckboxProps, 'checked' | 'onChange' | 'disabled'>
  isUserFan?: boolean
  preContentProps?: Omit<TypographyProps, 'children'>
  blueTagProps?: Omit<BoxProps, 'children'>
  isLoading?: boolean
  contentDetailProps?: Omit<BoxProps, 'children'>
}

export const VoucherItem = ({
  item,
  isActive,
  toggleVoucher,
  props,
  expiredTextProps,
  tag,
  iconProps,
  type = 'radio',
  checkboxProps,
  preContentProps,
  contentDetailProps,
  isLoading,
}: VoucherItemProps) => {
  const isUnavailable = isUnavailableVoucher(item)
  const isTheAutoApplied = isTheAutoAppliedVoucher(item)
  const positionExpiredText = expiredTextProps?.position || 'right'
  const t = useTranslations()
  const renderTextPromotion =
    item?.simple_action == 'by_percent' ? `${item?.discount_amount}%` : formatNumber(item?.discount_amount)
  const cantInteract = isUnavailable || isLoading || isTheAutoApplied
  const isChangeCursor = isUnavailable || isTheAutoApplied

  return (
    <Box
      onClick={!cantInteract ? toggleVoucher : undefined}
      {...props}
      sx={{
        padding: { xs: '8px', xl: '12px' },
        position: 'relative',
        cursor: isChangeCursor ? 'not-allowed' : 'pointer',
        opacity: 1,
        height: '100%',
        gap: 1,
        display: 'flex',
        flexDirection: 'column',
        ...props?.sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',

          gap: 0,
          direction: 'row',
          alignItems: 'start',
          position: 'relative',
          flex: 1,
          minHeight: 0, // KEY FIX: Allow flex child to shrink below content size
        }}
      >
        {/* content */}
        <Box
          sx={{
            // background: 'linear-gradient(135deg, #f64826 0%, #bc0f01 100%)',
            border: '2px solid #f46a00',
            borderRadius: '6px',
            color: 'white',
            width: '100%',
            display: 'flex',
            minHeight: 0, // KEY FIX: Allow flex child to shrink
            alignItems: 'stretch',
            position: 'relative',
            backgroundColor: '#fff',
            // p: '.4em',
            // pl: '.6em',
            // gap: '6px',
            height: '100%',
            boxSizing: 'border-box',
          }}
        >
          {/* action btn */}
          {type == 'checkbox' && (
            <Checkbox
              checked={isActive}
              disabled={isUnavailable}
              {...checkboxProps}
              sx={{
                cursor: isChangeCursor ? 'not-allowed' : 'pointer',
                position: 'absolute',
                top: '.3em',
                right: '0',
                zIndex: 4,
                ...checkboxProps?.sx,
                border: '1px solid',
                borderColor: 'rgba(0, 0, 0, 0.2)',
                '& .MuiSvgIcon-root': {
                  fill: 'none',
                  width: '12px',
                  height: '12px',
                },
                '&.Mui-checked': {
                  borderColor: '#17B26A',
                },
                '&.Mui-checked .MuiSvgIcon-root': {
                  fill: '#17B26A',
                  scale: '1.2',
                },
              }}
            />
          )}
          {/* decor */}
          {/* <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              top: 0,
              left: 0,
              zIndex: 0,
              mixBlendMode: 'soft-light',
              borderRadius: '0px 8px 8px 0px',
              overflow: 'hidden',
            }}
          >
            <Image
              src={URL_DECOR + 'voucher-bg-decor.png'}
              alt={''}
              width={332}
              height={96}
              style={{ mixBlendMode: 'soft-light', width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </Box> */}

          <span
            className="rounded-custom absolute left-[100px] top-[0] z-[4] h-[15px] w-[15px] -translate-x-1/2 -translate-y-1/2 rounded-full border-[2px] border-solid border-[#f46a00] bg-[#f46a00]"
            style={{
              clipPath: 'polygon(0 calc(50% - 2px), 100% calc(50% - 2px), 100% 100%, 0% 100%)',
            }}
          ></span>
          <span
            className="rounded-custom absolute bottom-[0] left-[100px] z-[4] h-[15px] w-[15px] -translate-x-1/2 translate-y-1/2 rounded-full border-[2px] border-solid border-[#f46a00] bg-[#f46a00]"
            style={{
              clipPath: 'polygon(0 0, 100% 0, 100% calc(50% + 2px), 0 calc(50% + 2px))',
            }}
          ></span>
          {/* <span className="absolute bottom-[0] left-[0] h-[15px] w-[15px] -translate-x-1/2 translate-y-1/2 rounded-full bg-[#fff]"></span> */}

          {/* title */}
          <Box
            sx={{
              fontSize: { xs: '1rem', md: '1.25rem' },
              fontWeight: 600,
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 100,
              minHeight: 100,
              flexShrink: 0,
              zIndex: 3,
              padding: '.4em',
              borderRight: '2px dashed #f46a00',
              color: '#3a3a3a',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                color: '#f46a00',
              }}
            >
              <Typography
                component={'span'}
                sx={{ position: 'relative', zIndex: 1 }}
                fontSize={'12px'}
                textTransform={'uppercase'}
              >
                {t('Voucher')}
              </Typography>
              <Typography
                component={'span'}
                sx={{ position: 'relative', zIndex: 1, textTransform: 'uppercase' }}
                fontFamily={'oswald'}
                fontSize={{ xs: '1.25em' }}
                fontWeight={600}
                lineHeight={1}
              >
                -{renderTextPromotion}
              </Typography>
            </Box>
          </Box>

          {/* detail */}
          <Box
            sx={{
              flexGrow: 1,
              minHeight: 0, // KEY FIX: Critical for proper height calculation
              minWidth: 0, // KEY FIX: Prevents overflow issues
              position: 'relative',
              zIndex: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Box
              {...contentDetailProps}
              sx={{
                flex: 1,
                // backgroundColor: 'primary.contrastText',
                color: 'primary.main',
                padding: { xs: '8px 24px 8px 8px', md: '8px 32px 8px 24px' },
                borderRadius: '5px',
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                height: '100%',
                ...contentDetailProps?.sx,
              }}
            >
              {tag && <Tag text={tag} />}
              {isUnavailable && (
                <Typography
                  color="#F04438"
                  {...preContentProps}
                  sx={{ fontSize: '13px', ...preContentProps?.sx }}
                >
                  {t('Chưa đủ điều kiện')}
                </Typography>
              )}
              <Typography
                fontWeight={400}
                sx={{
                  fontSize: '14px',
                }}
              >
                {parser(item?.description)}
              </Typography>
              {/* {positionExpiredText === 'right' && (
                <Box sx={{ mt: 0.5 }}>
                  <ExpiredText item={item} isUnavailable={isUnavailable} />
                </Box>
              )} */}
            </Box>
            {type == 'radio' && (
              <IconButton
                disabled={isUnavailable}
                {...iconProps}
                sx={{ color: 'primary.main', flexShrink: 0, ...iconProps?.sx }}
              >
                {isActive ? (
                  <Icon.Check sx={{ fontSize: '1rem', color: 'inherit' }} />
                ) : (
                  <Box
                    sx={{
                      width: '16px',
                      height: '16px',
                      borderRadius: '999px',
                      color: 'inherit',
                      border: '1px solid',
                      borderColor: 'primary.main',
                    }}
                  ></Box>
                )}
              </IconButton>
            )}
          </Box>
        </Box>
      </Box>
      {/* {positionExpiredText === 'bottom' && (
        <ExpiredText item={item} isUnavailable={isUnavailable} {...expiredTextProps?.props} />
      )} */}
    </Box>
  )
}

const ExpiredText = ({
  item,
  isUnavailable,
  ...props
}: {
  item: IListPromotionItem
  isUnavailable: boolean
}) => {
  if (!item?.to_date) return null
  return (
    <Typography
      variant="caption"
      fontWeight={300}
      {...props}
      sx={{
        display: 'flex',
        columnGap: 0.5,
        justifyContent: 'space-between',
        width: '100%',
        flexWrap: 'wrap',
      }}
    >
      <Box component={'span'}>
        <Box component={'span'} className="text">
          {'HSD: '}
        </Box>
        <Typography sx={{ color: 'primary.main', fontWeight: 300 }} component={'span'} variant="caption">
          {dayjs(item?.to_date).format('DD/MM/YYYY')}
        </Typography>
      </Box>
    </Typography>
  )
}

const Tag = ({ text }: { text: string }) => {
  return (
    <Typography
      variant="body2"
      fontWeight={300}
      sx={{
        padding: '4px 8px',
        lineHeight: 1.3,
        background: '#F04438',
        color: 'white',
        borderRadius: '999px',
      }}
    >
      {text}
    </Typography>
  )
}
